module.exports = __webpack_public_path__ + "static/media/2024-normalized.bf07c4e3.csv";